import API from "./API";
// import passportsAPI from "./passportsAPI";
import Alert from "../stores/alerts";
import app from "../stores/app";
import user from "../stores/user";
import {writable} from "svelte/store";

export const LOADER = {
    NONE: 0,
    PAGE: 1,
    POPUP: 2,
}

const mm = writable(false);

const R = {
    handle: async (func, params, success, failure, loader = 0) => {
        if (loader == LOADER.PAGE) {
            app.showPageLoader();
        } else if (loader == LOADER.POPUP) {
            app.showPopupLoader();
        }

        mm.set(true);
        //const [err, result] = await func(params);
        const result = await func(params);
        mm.set(false);

        if (loader == LOADER.PAGE) {
            app.hidePageLoader();
        } else if (loader == LOADER.POPUP) {
            app.hidePopupLoader();
        }

        if (result.error) {
            if (result.error.code == 'no_login') {
                // Alert.warning("Λογαριασμός", "Έχεις αποσυνδεθεί από τον λογαριασμό σου!");
                user.clearToken();
            }
            failure(result.error);
        } else {
            success(result.data);
        }
    },

    app: {
        login: (data) => API.POST(`login`, data),
        initialize: () => API.GET('initialize'),
        editSettings: (data) => API.POST('edit-settings', data),
    },

    member: {
        index: (data) => API.POST('members', data),
        details: (id) => API.GET(`member/${id}/details`),
        create: (data) => API.POST('member/create', data),
        edit: (data) => API.POST(`member/edit`, data),
        delete: (id) => API.POST('member/delete', {id}),
        activationMail: (id) => API.POST('member/activation-mail', {id}),
        merge: (data) => API.POST(`members/merge`, data),
        setVote: (data)=> API.POST(`member/set-vote`, data),
    },


    product: {
        index: (data) => API.POST('products', data),
        details: (id) => API.GET(`product/${id}/details`),
        create: (data) => API.POST('product/create', data),
        edit: (data) => API.POST(`product/edit`, data),
        delete: (id) => API.POST('product/delete', {id}),
        uploadImage: (data) => API.UPLOAD(`product/image`, data.data, data.image),
    },

    order: {
        index: (data) => API.POST('orders', data),
        details: (id) => API.GET(`order/${id}/details`),
        edit: (data) => API.POST(`order/edit`, data),
        delete: (id) => API.POST('order/delete', {id}),
        sendMail: (id) => API.POST(`order/send-mail`, {id}),
    },

    passport: {
        index: (data) => API.POST('passports', data),
        getRange: (data) => API.POST('passports/get-range', data),
        checkRange: (data) => API.POST('passports/check-range', data),
        details: (id) => API.GET(`passports/${id}/details`),
        create: (data) => API.POST(`passports/create`, data),
        edit: (data) => API.POST(`passports/edit`, data),
        delete: (id) => API.POST('passports/delete', {id}),
        export: (data) => API.POST('passports/export', data),

        apiLogin: () => API.POST('passports-api/login'),
        apiRequest: (data) => API.POST('passports-api/request', data),
    },

    passportReport: {
        index: (data) => API.POST('passports-report', data),
        export: (data) => API.POST('passports-report/export', data),
    },

    document: {
        initialize: () => API.GET('documents/initialize'),
        index: (data) => API.POST('documents', data),
        details: (id) => API.GET(`document/${id}/details`),
        create: (data) => API.UPLOAD(`document/create`, data.document, data.file),
        // create: (data) => API.POST('document/create', data),
        edit: (data) => API.POST(`document/edit`, data),
        delete: (id) => API.POST('document/delete', {id}),
    },

    documentCategory: {
        index: (data) => API.POST('document-categoriess', data),
        details: (id) => API.GET(`document-category/${id}/details`),
        create: (data) => API.POST('document-category/create', data),
        edit: (data) => API.POST(`document-category/edit`, data),
        delete: (id) => API.POST('document-category/delete', {id}),
    },

    user: {
        index: (data) => API.POST('users', data),
        details: (id) => API.GET(`user/${id}/details`),
        create: (data) => API.POST('user/create', data),
        edit: (data) => API.POST(`user/edit`, data),
        delete: (id) => API.POST('user/delete', {id}),
    },

    page: {
        index: (data) => API.GET('pages'),
        details: (id) => API.GET(`page/${id}/details`),
        edit: (data) => API.POST(`page/edit`, data),
        delete: (id) => API.POST('page/delete', {id}),
    },

    shipping: {
        index: (data) => API.GET('shipping'),
        create: (data) => API.POST('shipping/create', data),
        edit: (data) => API.POST(`shipping/edit`, data),
        delete: (id) => API.POST('shipping/delete', {id}),
    },

    courier: {
        // index: (data) => API.GET('couriers'),
        create: (data) => API.POST('courier/create', data),
        edit: (data) => API.POST(`courier/edit`, data),
        delete: (id) => API.POST('courier/delete', {id}),
    },

    region: {
        // index: (data) => API.GET('shipping'),
        // create: (data) => API.POST('shipping/create', data),
        edit: (data) => API.POST(`region/edit`, data),
        // delete: (id) => API.POST('shipping/delete', {id}),
    },

    autocomplete: {
        search: (data) => API.POST('autocomplete/search', data),
    },

    import: {
        check: (data) => API.POST(`import/check`, data),
        import: (data) => API.POST(`import`, data),
    },

    report: {
        initialize: () => API.GET('report/initialize'),
        export: (data) => API.POST(`report/export`, data),
    }
};

export default R;
export {mm as requestingStore};